<template>
  <div>
    <el-image
      class="image"
      v-for="(item,index) in imgArr"
      :key="index"
      :src="item"
      :preview-src-list="getPreviewImgList(index,imgArr)"
      style="width: 100px;height: 100px;"
    >
      <div slot="placeholder" class="image_slot">
        <span class="el-icon-loading"></span>
      </div>
    </el-image>
    <!-- <div class="imgClass">1/ 3</div> -->
    <div class="flex" v-if="videoArr.length">
      <div class="video" v-for="(item, index) in videoArr" :key="index">
        <video width="100" height="100" controls>
          <source :src="item.fileUrl" type="video/mp4" />
        </video>
      </div>
    </div>

    <template v-if="!imgArr.length && !videoArr.length">
      <img src="@/assets/img/empty.png" style="width: 100px;display: block;margin: 30px auto;" />
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // imgArr: [
      //   'https://apintel.oss-cn-shenzhen.aliyuncs.com/admin-api/1722394167287tmp_8493067f6e5225164836db54fa3662521ca4feca1467ca62.png',
      //   'https://apintel.oss-cn-shenzhen.aliyuncs.com/admin-api/17222167648483QptEQgnhQNWf788338d9247a799f93a2d8369c05316.png',
      // ],
    }
  },
  props: {
    imgArr: {
      type: Array,
      default() {
        return []
      },
    },
    videoArr: {
      type: Array,
      default() {
        // return [{ fileUrl: '' }, { fileUrl: '' }]
        return []
      },
    },
  },
  methods: {
    getPreviewImgList(index, imgArr) {
      let arr = []
      let i = 0
      for (i; i < imgArr.length; i++) {
        arr.push(imgArr[i + index])
        if (i + index >= imgArr.length - 1) {
          index = 0 - (i + 1)
        }
      }
      return arr
    },
  },
}
</script>
<style>
.el-icon-full-screen:before {
  /* display: none !important; */
}
</style>
<style scoped lang='less'>
.flex {
  display: flex;
  .video {
    margin-right: 10px;
  }
}
.image {
  margin-right: 10px;
  &_slot {
    
  }
}
.imgClass {
  position: absolute;
  bottom: 50px;
  font-size: 14px;
}

.el-icon-loading {
  font-size: 30px;
}
</style>